export default "__VITE_ASSET__cff5bdce__"